export default __webpack_public_path__ + "static/footer-map-03228220ebf2de382190bb2dfcc7eae2.png";